import { render, staticRenderFns } from "./ClearCartsModal.vue?vue&type=template&id=cf44fce8&"
import script from "./ClearCartsModal.vue?vue&type=script&lang=js&"
export * from "./ClearCartsModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports